import { NgFor, NgIf } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { DynamicModule } from 'ng-dynamic-component';
import { StoryblokDirective } from 'src/app/directive/storyblok.directive';

@Component({
    selector: 'app-ticker',
    imports: [NgFor, NgIf, RouterModule, DynamicModule, StoryblokDirective],
    templateUrl: './ticker.component.html',
    styleUrl: './ticker.component.scss'
})
export class TickerComponent implements OnChanges, AfterViewInit {
  components: any;

  constructor() {
    import('src/app/storyblok/components').then((cp) => {
      this.components = cp.Components;
    });
  }

  @ViewChild('element') element!: ElementRef;
  @ViewChild('parent') parent!: ElementRef;

  @Input() _uid!: string;
  @Input() component!: string;
  @Input() title: string = '';
  @Input() images!: any[];
  @Input() _editable: any;

  ngOnChanges(changes: SimpleChanges): void {
    this.images.forEach((image) => {
      image.mode = 'contain';
      image.width = 300;
      image.height = 80;
      1;
    });
  }

  @HostListener('window:resize', [])
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.parent.nativeElement.style.setProperty(
        '--width',
        '-' + (this.element.nativeElement.clientWidth + 96) + 'px'
      );
    }, 50);
  }
}
